import { Bookmark, Clock, Compass, House, List, type LucideIcon, Settings, Sparkles, UserPlus, Users } from "lucide-preact";
import { useAuthModal } from "../contexts/AuthModalContext";

type NavButtonProps = {
  icon: LucideIcon;
  label: string;
  href: string;
  class?: string;
};

const DesktopNavButton = ({ icon: Icon, label, href, class: className }: NavButtonProps) => (
  <a
    href={href}
    class={`desktop-nav-item flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 text-neutral-700 dark:text-neutral-300 ${className ?? ""}`}
  >
    <Icon class="w-5 h-5" />
    <span class="text-sm font-medium">{label}</span>
  </a>
);

const SignedInNav = () => (
  <nav class="visible-signedin flex flex-col gap-1">
    <DesktopNavButton label="Feed" class="feed-menu" icon={House} href="/" />
    <DesktopNavButton label="For You" class="foryou-menu" icon={Sparkles} href="/recommended" />
    <DesktopNavButton label="Explore Articles" class="articles-menu" icon={Compass} href="/articles" />
    <DesktopNavButton label="Explore Authors" class="authors-menu" icon={Users} href="/authors" />
    <DesktopNavButton label="Collections" class="collections-view-menu" icon={Bookmark} href="/collections" />
    <DesktopNavButton label="Manage Collections" class="collections-manage-menu" icon={List} href="/collections/manage" />
    <DesktopNavButton label="History" class="history-menu" icon={Clock} href="/profile" />
    <DesktopNavButton label="Following" class="following-menu" icon={UserPlus} href="/profile/following" />
    <DesktopNavButton label="Settings" class="settings-menu" icon={Settings} href="/profile/settings" />
  </nav>
);

const AnonymousNav = () => (
  <nav class="visible-anonymous flex flex-col gap-1">
    <DesktopNavButton label="Home" class="feed-menu" icon={House} href="/" />
    <DesktopNavButton label="Explore Articles" class="articles-menu" icon={Compass} href="/articles" />
    <DesktopNavButton label="Explore Authors" class="authors-menu" icon={Users} href="/authors" />
    <DesktopNavButton label="Settings" class="settings-menu" icon={Settings} href="/profile/settings" />
  </nav>
);

export const DesktopNav = () => {
  const { showAuthModal } = useAuthModal();

  const handleSignIn = (event: MouseEvent) => {
    event.preventDefault();
    showAuthModal("Sign in", "Create an account or sign in to continue");
  };

  return (
    <div class="hidden lg:block fixed top-8 w-64 p-3 bg-white dark:bg-black rounded-xl shadow-sm" style={{ left: "calc(50% - 256px - 270px)" }}>
      <div class="mb-4 px-3 flex justify-between items-center">
        <a href="/" class="text-3xl font-bold text-neutral-700 dark:text-neutral-50">
          !tldr
        </a>{" "}
        <a
          href="/auth"
          onClick={handleSignIn}
          class="visible-anonymous px-3 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg text-center"
          data-test-click="sign-in-desktop-nav"
        >
          Sign in
        </a>
      </div>
      <SignedInNav />
      <AnonymousNav />
    </div>
  );
};
